export default __webpack_public_path__ + "static/media/graveStone.60db38db.jpeg";